import { ActionAny, createActions } from 'src/utils/createActions';
import { DemoPageData } from 'src/react/demoPage/state/DemoPageState';

export type DemoPinModeLeaveActions =
    ActionAny<'save' | 'cancel', DemoPageData>;
export const DEMO_PIN_MODE_LEAVE_ACTIONS =
    createActions<'save' | 'cancel', DemoPageData>('DEMO_PIN_MODE_LEAVE');
